export const SERVICE_REQUEST_COLORS = [
	{ value: "red", labelEn: "Red", labelAr: "أحمر", color: "#ff4d4f" },
	{ value: "orange", labelEn: "Orange", labelAr: "برتقالي", color: "#fa8c16" },
	{ value: "yellow", labelEn: "Yellow", labelAr: "أصفر", color: "#fadb14" },
	{ value: "green", labelEn: "Green", labelAr: "أخضر", color: "#52c41a" },
	{ value: "cyan", labelEn: "Cyan", labelAr: "سماوي", color: "#13c2c2" },
	{ value: "blue", labelEn: "Blue", labelAr: "أزرق", color: "#1890ff" },
	{ value: "purple", labelEn: "Purple", labelAr: "بنفسجي", color: "#722ed1" },
	{ value: "pink", labelEn: "Pink", labelAr: "وردي", color: "#eb2f96" },
	{ value: "black", labelEn: "Black", labelAr: "أسود", color: "#000000" },
	{ value: "gray", labelEn: "Gray", labelAr: "رمادي", color: "#8c8c8c" },
];

export function getLocalizedColorLabel(color, lang = "en") {
	if (!color) return "";
	const found = SERVICE_REQUEST_COLORS.find(
		(c) => c.value === color || c.labelEn === color || c.labelAr === color
	);
	if (!found) return color;
	return lang === "ar" ? found.labelAr : found.labelEn;
}

export function getColorByValue(color) {
	if (!color) return null;
	return (
		SERVICE_REQUEST_COLORS.find(
			(c) => c.value === color || c.labelEn === color || c.labelAr === color
		) || null
	);
}
